import { render, staticRenderFns } from "./productCategoryManage.vue?vue&type=template&id=37855b70&scoped=true"
import script from "./productCategoryManage.vue?vue&type=script&lang=js"
export * from "./productCategoryManage.vue?vue&type=script&lang=js"
import style0 from "./productCategoryManage.vue?vue&type=style&index=0&id=37855b70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37855b70",
  null
  
)

export default component.exports